<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="dt.exportCSV()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="funcionalidades" [columns]="cols" [rows]="10" [paginator]="true" [globalFilterFields]="['codFuncionalidadeApp','dscFuncionalidadeApp','nmeFuncionalidadeApp', 'nmeGrupo', 'urlPath']"
                     [(selection)]="selectedFuncionalidades" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'funcionalidade.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
						<th pSortableColumn="codFuncionalidadeApp">{{ 'funcionalidade.codigo' | translate }}<p-sortIcon field="codFuncionalidadeApp"></p-sortIcon></th>
                        <th pSortableColumn="dscFuncionalidadeApp">{{ 'funcionalidade.descricao' | translate }}<p-sortIcon field="dscFuncionalidadeApp"></p-sortIcon></th>
						<th pSortableColumn="nmeFuncionalidadeApp">{{ 'funcionalidade.nome' | translate }}<p-sortIcon field="nmeFuncionalidadeApp"></p-sortIcon></th>
						<th pSortableColumn="nmeGrupo">{{ 'funcionalidade.grupo' | translate }} <p-sortIcon field="nmeGrupo"></p-sortIcon></th>
                        <th pSortableColumn="urlPath">{{ 'funcionalidade.url' | translate }}<p-sortIcon field="urlPath"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-funcionalidade>
                    <tr>
						<td><span class="p-column-title" style="text-align: center;">Codigo Empresa</span>
                            {{funcionalidade.codFuncionalidadeApp}}
                        </td>
						<td><span class="p-column-title" style="text-align: center;">Nome Empresa</span>
                            {{funcionalidade.dscFuncionalidadeApp}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">Codigo Aplicacao</span>
                            {{funcionalidade.nmeFuncionalidadeApp}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">Descricao Aplicacao</span>
                            {{funcionalidade.nmeGrupo}}
						</td>
						<td><span class="p-column-title" style="text-align: center;">Nome Aplicacao</span>
                            {{funcionalidade.urlPath}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-bookmark" class="p-button-rounded p-button-secondary p-mr-2" (click)="viewFuncionalidade(funcionalidade)"></button>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editFuncionalidade(funcionalidade)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteEmpresa(funcionalidade)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ 'label.totalde' | translate }} {{funcionalidades ? funcionalidades.length : 0 }} {{ 'funcionalidade.funcionalidades' | translate }}.
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="funcionalidadeDialog" [style]="{width: '650px'}" header="{{ 'funcionalidade.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                     <h6>{{ 'funcionalidade.pai' | translate }}</h6>
                    <span class="p-float-label">
                    <p-dropdown inputId="funcionalidadesPai" [options]="funcionalidadesPai" [(ngModel)]="funcionalidadePai.codFuncionalidadeApp" optionValue="codFuncionalidadeApp" optionLabel="nmeFuncionalidadeApp" [autoDisplayFirst]="false"></p-dropdown>
                     </span>
                </div>
                <div class="p-field">
                    <h6>{{ 'funcionalidade.nome' | translate }}</h6>
                    <input type="text" pInputText id="nmeFuncionalidadeApp" [(ngModel)]="funcionalidade.nmeFuncionalidadeApp" required autofocus />
                </div>   
				<div class="p-field">
                     <h6>{{ 'funcionalidade.descricao' | translate }}</h6>
                    <input type="text" pInputText id="dscFuncionalidadeApp" [(ngModel)]="funcionalidade.dscFuncionalidadeApp" required autofocus />
                </div>
				<div class="p-field">
                    <h6>{{ 'funcionalidade.grupo' | translate }}</h6>
                    <input type="text" pInputText id="nmeGrupo" [(ngModel)]="funcionalidade.nmeGrupo" required autofocus />
                </div>
                <div class="p-field">
                     <h6>{{ 'funcionalidade.url' | translate }}</h6>
                    <input type="text" pInputText id="urlPath" [(ngModel)]="funcionalidade.urlPath" required autofocus />
                </div>
                <div class="p-field">
                     <h6>{{ 'aplicacao.aplicacao' | translate }}</h6>
                    <span class="p-float-label">
                    <p-dropdown inputId="aplicacao" [options]="aplicacoes" [(ngModel)]="aplicacao.codAplicacao" optionValue="codAplicacao" optionLabel="nmeAplicacao" [autoDisplayFirst]="false"></p-dropdown>
                     </span>
                </div>
                <div class="p-field">
                <h6>{{ 'funcionalidade.perfis' | translate }}</h6>
                <p-pickList [source]="sourcePerfil" [target]="targetPerfil">
                    <ng-template let-perfil pTemplate="perfis">
                        <div>
                            <div style="font-size:14px;float:right;margin:15px 5px 0 0">{{perfil.dscPerfil}}</div>
                        </div>
                    </ng-template>
                </p-pickList>

                </div>
                
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveFuncionalidade()" *ngIf="blocked == false"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
